import { LEFT_UPLOADS_KEY, uploadStorageCleared } from './storageKeys';

/**
 * Images whose upload the person left on purpose: Cancel, or starting another
 * upload over it. The server cannot tell those from uploads whose tab closed
 * or crashed (both are drafts with no transfer running), so this browser
 * remembers, and the top bar does not call them interrupted. Kept for as long
 * as an unfinished image lives on the server; an image picked up again (its
 * upload page adopts it, or its transfer starts) is taken off the list.
 */
const KEEP_MS = 26 * 3600_000;

function read(): Record<string, number> {
  try {
    const raw = JSON.parse(window.localStorage.getItem(LEFT_UPLOADS_KEY) ?? '{}') as unknown;
    if (!raw || typeof raw !== 'object') return {};
    const now = Date.now();
    return Object.fromEntries(Object.entries(raw as Record<string, unknown>).filter(([, at]) => typeof at === 'number' && now - at < KEEP_MS)) as Record<string, number>;
  } catch {
    return {};
  }
}

function write(left: Record<string, number>): void {
  if (uploadStorageCleared()) return;
  try {
    if (Object.keys(left).length) window.localStorage.setItem(LEFT_UPLOADS_KEY, JSON.stringify(left));
    else window.localStorage.removeItem(LEFT_UPLOADS_KEY);
  } catch {
    /* storage unavailable: the top bar may mention them, nothing worse */
  }
}

export function markLeft(imageIds: readonly string[]): void {
  if (!imageIds.length) return;
  const left = read();
  for (const id of imageIds) left[id] = Date.now();
  write(left);
}

export function unmarkLeft(imageIds: readonly string[]): void {
  const left = read();
  if (!imageIds.some((id) => id in left)) return;
  for (const id of imageIds) delete left[id];
  write(left);
}

export function leftUploads(): ReadonlySet<string> {
  return new Set(Object.keys(read()));
}
